import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0026',
    ecrans: ['00-2']
});
